import { render, staticRenderFns } from "./modalCederClientes.vue?vue&type=template&id=759f3880"
import script from "./modalCederClientes.vue?vue&type=script&lang=js"
export * from "./modalCederClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports